import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    CanActivate,
    CanActivateChild,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
    ActivatedRoute
} from '@angular/router';
import { Observable } from 'rxjs';
import { DoctorsService } from '../services/doctors.service';
import { ProviderStateService } from '../services/provider-state.service';

@Injectable({
    providedIn: 'root'
})
export class AuthEgdGuard implements CanActivate, CanActivateChild {
    slug: string = "";
    constructor(
        private readonly doctors: DoctorsService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly providerstateService: ProviderStateService
    ) {
        this.slug = this.providerstateService.getProviderSlug();
    }
    async canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        // return new Observable<boolean>((obs) => {
        //     this.doctors
        //         .getDoctorIDCardData(sessionStorage.getItem('userid'))
        //         .subscribe((result) => {
        //             obs.next(true);
        //         });
        // });

        return await this.DoctorGuard(next, state);

    }

    async canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        // return new Observable<boolean>((obs) => {
        //     this.doctors
        //         .getDoctorIDCardData(sessionStorage.getItem('userid'))
        //         .subscribe((result) => {
        //             obs.next(true);
        //         });
        // });

        return await this.DoctorGuard(next, state);


    }

    async DoctorGuard(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return await this.doctors
            .getDoctorIDCardData(sessionStorage.getItem('userid'))
            .toPromise()
            .then((result) => {
                if (result.success) {
                    return true;
                }
                else {
                    this.router.navigate(["/" + this.slug + "/accessdenied"], { relativeTo: this.activatedRoute });
                    return false;
                }

            }).catch((error: HttpErrorResponse) => {
                // let redirectTo = route.pathFromRoot
                //   .filter(p => p !== route && p.url !== null && p.url.length > 0)
                //   .reduce((arr, p) => arr.concat(p.url.map(u => u.path)), new Array<string>());
                // this.router.navigate(redirectTo.concat("dashboard"), { relativeTo: this.activatedRoute });
                this.router.navigate(["/" + this.slug + "/accessdenied"], { relativeTo: this.activatedRoute });
                return false;
            });
    }
}



